export default __webpack_public_path__ + "static/media/girl3.fab93fe0.svg";